import React from 'react';
import { component_tool } from '@/tool'
import { WizTableForm } from "../../index";
import organization from './config-organization';

let {  WizPopover } = component_tool;
let organizationConfig = organization(this, { apiParams: { state: 1} });

const columns = () => {
    return [
        {
            title: '账号',
            name: 'userName',
            dataIndex: 'userName',
            searchItem: {},
            tableItem: {
                width: 150
            }
        },
        {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName',
            searchItem: {},
            tableItem: {
                width: 100
            }
        },
        {
            title: '手机号',
            name: 'mobile',
            dataIndex: 'mobile',
            tableItem: {
                width: 120
            }
        },
        {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            dict: [
                { code: 1, codeName: '激活' },
                { code: 0, codeName: '禁用' },
            ],
            searchItem: {
                type: 'select',
                width: 171
            },
            tableItem: {
                width: 100
            }
        },
        {
            title: "组织机构",
            name: "organizationIdList",
            searchItem: {
                diy: WizTableForm,
                ...organizationConfig
            }
        },
        {
            title: "任职信息",
            name: "identityInfos",
            formItem: {},
            tableItem: {
                width: 300,
                render: (val = [], record) => {
                    if (!val.length) { return '暂无任职' }
                    let { orgName, positionName } = val[0]
                    let _titleView = [`${orgName}-${positionName}`]
                    if (val.length > 1) {
                        _titleView.push(<span className='manager-person-text-color'> ...</span>)
                    }

                    return (
                        <WizPopover
                            content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)}
                            placement="rightTop"
                        >
                            {_titleView}
                        </WizPopover>
                    )
                }
            }
        },
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'personManage/getListByPage',
        ...api
    }
};

const person = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        rowkey: 'personId',
        rowTitle: 'userName',
        rowName: 'fullName',
        columns: columns(),
        tableApi: tableApi(api),
        title: '选择用户'
    }
};

export default person
